import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fdfce55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-text" }, "Carregando...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "soon-badge mb-3" }, " Em breve ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2 filter-title" }, "Filtros")
], -1))
const _hoisted_9 = { class: "d-flex flex-column justify-content-start" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "Status", -1))
const _hoisted_11 = { class: "select-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Todos", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1))
const _hoisted_15 = { class: "d-flex flex-column justify-content-start mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "Tags", -1))
const _hoisted_17 = { class: "select-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Todas", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1))
const _hoisted_21 = { class: "d-flex flex-column justify-content-start mt-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "Tipo de imóvel", -1))
const _hoisted_23 = { class: "select-container" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Todos", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1))
const _hoisted_27 = { class: "d-flex flex-column justify-content-start mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "Estado", -1))
const _hoisted_29 = { class: "select-container" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Todos", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1))
const _hoisted_33 = { class: "opportunities-container" }
const _hoisted_34 = { class: "panel-header" }
const _hoisted_35 = { class: "toggle-sidebar-btn" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Meu Painel", -1))
const _hoisted_37 = { class: "tabs" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_PanelList = _resolveComponent("PanelList")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Sidebar, {
            sidebarOpen: _ctx.sidebarOpen,
            isMobile: _ctx.isMobile
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.status) = $event)),
                      class: "form-control",
                      disabled: ""
                    }, _hoisted_13, 512), [
                      [_vModelSelect, _ctx.status]
                    ]),
                    _hoisted_14
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status) = $event)),
                      class: "form-control",
                      disabled: ""
                    }, _hoisted_19, 512), [
                      [_vModelSelect, _ctx.status]
                    ]),
                    _hoisted_20
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
                      class: "form-control",
                      disabled: ""
                    }, _hoisted_25, 512), [
                      [_vModelSelect, _ctx.status]
                    ]),
                    _hoisted_26
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status) = $event)),
                      class: "form-control",
                      disabled: ""
                    }, _hoisted_31, 512), [
                      [_vModelSelect, _ctx.status]
                    ]),
                    _hoisted_32
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["sidebarOpen", "isMobile"]),
          _createElementVNode("div", {
            class: _normalizeClass(["opportunities-main", { 'isNotMobile': !_ctx.isMobile }])
          }, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("i", {
                    class: "fa-solid fa-sliders",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSidebar()))
                  })
                ]),
                _hoisted_36
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_Tabs, { tabs: _ctx.tabs }, {
                  default: _withCtx(({ activeTab }) => [
                    (activeTab === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createVNode(_component_PanelList, { opportunities: _ctx.reportsOpportunities }, null, 8, ["opportunities"])
                        ]))
                      : (activeTab === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createVNode(_component_PanelList, {
                              opportunities: _ctx.fundingOpportunities,
                              isFunding: true
                            }, null, 8, ["opportunities"])
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["tabs"])
              ])
            ])
          ], 2)
        ]))
  ]))
}